// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsPreview_newsContainer__BcOaR {
	max-width: 100%;
	margin: 0 auto;
	padding: 2rem 1rem;
	background-color: #ffffff;
	border-radius: 10px;
}

.NewsPreview_newsContainer__BcOaR h1 {
	text-transform: uppercase;
	font-family: "Ysabeau SC";
	color: #333;
	text-align: center;
	margin-bottom: 1rem;
}

.NewsPreview_slider__sjtoo {
	overflow: hidden;
}

.NewsPreview_newsPreviewA__vdJwI {
	text-decoration: none;
	color: inherit;
	display: block;
}

.NewsPreview_newsPreviewA__vdJwI:hover {
	text-decoration: none;
}

.NewsPreview_card__02IGf {
	position: relative;
	margin: 0 10px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	background-color: #df2525;
	border-radius: 15px;
	overflow: hidden;
	transition: transform 0.3s ease;
}

.NewsPreview_card__02IGf:hover {
	transform: translateY(-5px);
}

.NewsPreview_imgArea__VppO9 {
	position: relative;
	width: 100%;
	height: 200px;
	overflow: hidden;
}

.NewsPreview_imgArea__VppO9 img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: transform 0.3s ease;
}

.NewsPreview_imgArea__VppO9:hover img {
	transform: scale(1.1);
}

.NewsPreview_overlay__GitAf {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	opacity: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: opacity 0.3s ease;
}

.NewsPreview_imgArea__VppO9:hover .NewsPreview_overlay__GitAf {
	opacity: 1;
}

.NewsPreview_overlay__GitAf p {
	font-size: 1.2rem;
	color: #ffffff;
	text-align: center;
	padding: 1rem;
}

.NewsPreview_info__nKn31 {
	padding: 10px;
	text-align: center;
	color: #ffffff;
	height: 200px;
	overflow: hidden;
}

.NewsPreview_info__nKn31 h3 {
	margin: 15px 0 10px;
	font-size: 1.5rem;
	font-weight: bold;
	text-transform: uppercase;
	font-family: "Bebas Neue", sans-serif;
}

.NewsPreview_info__nKn31 p {
	font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/mainPage/NewsPreview/NewsPreview.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;CACX,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,yCAAyC;CACzC,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,+BAA+B;AAChC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,cAAc;CACd,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,yBAAyB;CACzB,qCAAqC;AACtC;;AAEA;CACC,eAAe;AAChB","sourcesContent":[".newsContainer {\r\n\tmax-width: 100%;\r\n\tmargin: 0 auto;\r\n\tpadding: 2rem 1rem;\r\n\tbackground-color: #ffffff;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.newsContainer h1 {\r\n\ttext-transform: uppercase;\r\n\tfont-family: \"Ysabeau SC\";\r\n\tcolor: #333;\r\n\ttext-align: center;\r\n\tmargin-bottom: 1rem;\r\n}\r\n\r\n.slider {\r\n\toverflow: hidden;\r\n}\r\n\r\n.newsPreviewA {\r\n\ttext-decoration: none;\r\n\tcolor: inherit;\r\n\tdisplay: block;\r\n}\r\n\r\n.newsPreviewA:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n.card {\r\n\tposition: relative;\r\n\tmargin: 0 10px;\r\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n\tbackground-color: #df2525;\r\n\tborder-radius: 15px;\r\n\toverflow: hidden;\r\n\ttransition: transform 0.3s ease;\r\n}\r\n\r\n.card:hover {\r\n\ttransform: translateY(-5px);\r\n}\r\n\r\n.imgArea {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 200px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.imgArea img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tobject-fit: cover;\r\n\ttransition: transform 0.3s ease;\r\n}\r\n\r\n.imgArea:hover img {\r\n\ttransform: scale(1.1);\r\n}\r\n\r\n.overlay {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\topacity: 0;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttransition: opacity 0.3s ease;\r\n}\r\n\r\n.imgArea:hover .overlay {\r\n\topacity: 1;\r\n}\r\n\r\n.overlay p {\r\n\tfont-size: 1.2rem;\r\n\tcolor: #ffffff;\r\n\ttext-align: center;\r\n\tpadding: 1rem;\r\n}\r\n\r\n.info {\r\n\tpadding: 10px;\r\n\ttext-align: center;\r\n\tcolor: #ffffff;\r\n\theight: 200px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.info h3 {\r\n\tmargin: 15px 0 10px;\r\n\tfont-size: 1.5rem;\r\n\tfont-weight: bold;\r\n\ttext-transform: uppercase;\r\n\tfont-family: \"Bebas Neue\", sans-serif;\r\n}\r\n\r\n.info p {\r\n\tfont-size: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newsContainer": `NewsPreview_newsContainer__BcOaR`,
	"slider": `NewsPreview_slider__sjtoo`,
	"newsPreviewA": `NewsPreview_newsPreviewA__vdJwI`,
	"card": `NewsPreview_card__02IGf`,
	"imgArea": `NewsPreview_imgArea__VppO9`,
	"overlay": `NewsPreview_overlay__GitAf`,
	"info": `NewsPreview_info__nKn31`
};
export default ___CSS_LOADER_EXPORT___;
